/**
 * Returns true when the path points at an individual order detail page
 * (e.g. '/orders/123'), excluding collection ('/orders') and special
 * routes like '/orders/new' and the legacy '/orders/create'.
 */
export const isOrderDetailPath = (path) => (
  typeof path === 'string' &&
  path.startsWith('/orders/') &&
  path !== '/orders/create' &&
  path !== '/orders/new'
);
